import React, { useEffect, useState } from "react";
import { Container, Row, Col, Breadcrumb, Accordion } from "react-bootstrap";
import Topnav from "../common/Topnav";
import Menubar from "../common/Menubar";
import { Link } from "react-router-dom";
import Footer from "../common/footer";
import Servicesslidebaar from "../sidebars/ServicesSidebar";
import EnquiryNow from "../common/EnquiryNow3";

const OBCCommittee = () => {
  const [modalShow, setModalShow] = React.useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Topnav />
      <Menubar />
      <div className="comminnerbackimage innerbackimage">
        <div className="text_banners_abcds">
          <h1>Other Backward Class Committee</h1>
          <div onClick={() => setModalShow(true)}>
            <span>
              <a className="btn btn-primary" href="#" role="button">
                Apply Now
              </a>
            </span>
          </div>
          <EnquiryNow show={modalShow} onHide={() => setModalShow(false)} />
        </div>
      </div>

      {/* container */}
      <Container className="About_us11">
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/">Home</Link>
          </Breadcrumb.Item>

          <Breadcrumb.Item active>
          Other Backward Class Committee
          </Breadcrumb.Item>
        </Breadcrumb>
        <Row>
          <Servicesslidebaar />
          <Col lg={9}>
            <h2 className="linkabout123">
            Other Backward Class Committee
            </h2>
            <div className="position-relative card table-nowrap table-card">
              <div className="table-responsive committe-table">
                <table className="table mb-0">
                  <thead className="small text-uppercase bg-body text-muted bg-secondary">
                    <tr>
                      <th>Name of Member</th>
                      <th>Designation</th>
                    </tr>
                  </thead>
                  <tbody>
                  <tr>
                            <td className="small">Dr. Sandeep Sahu, DSW</td>
                            <td className="small">Convener </td>
                        </tr>
                        <tr>
                            <td className="small">Dr. N.K Swamy, Director IQAC </td>
                            <td className="small">Member Secretary</td>
                        </tr>
                        <tr>
                            <td className="small">Mr. Preetam Sahu, Asst. Prof. Faculty of Arts & Humanities</td>
                            <td className="small">Member </td>
                        </tr>
                        <tr>
                            <td className="small">Mr. Gokul Prasad Sahu, Asst. Prof. Faculty of Science </td>
                            <td className="small">Member </td>
                        </tr>
                        <tr>
                            <td className="small">Dr. Garima Diwan, Associate Prof. Faculty of Arts & Humanities</td>
                            <td className="small">Member </td>
                        </tr>
                        <tr>
                            <td className="small">Dr. Poonam Verma, Asst. Prof. Faculty of Science</td>
                            <td className="small">Member </td>
                        </tr>
                        <tr>
                            <td className="small">Mr. Rameshwar Nishad, Asst. Prof. Faculty of Science </td>
                            <td className="small">Liaison officer for OBC Cell (nominated by Vice Chancellor) </td>
                        </tr>
                        <tr>
                            <td className="small">Mr. Ram Krishna Deshmukh, Asst. Prof. Faculty of Science</td>
                            <td className="small">Liaison officer for OBC Cell (nominated by Vice Chancellor) </td>
                        </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
      <Footer />
    </>
  );
};

export default OBCCommittee;
